module.exports = __webpack_public_path__ + "img/SAP.73968b99.svg";